import React, { useEffect } from "react";
import SEO from "../components/SEO";
import FAQ from "../components/FAQ";
import Advantages from "../components/Advantages";

const featureItems = [
  "Equities",
  "Commodities",
  "Fixed Returns",
  "Debt Instruments",
  "Currency",
  "IPO",
  "Gold Loan",
  "Mutual Fund",
  "SIP",
];

const coreValuesData = [
  {
    id: "01",
    img: "/images/core-values/1.avif",
    title: "Client-First Integrity",
    text: "We place client interests at the center of every decision, ensuring transparent pricing, ethical advisory practices, and strict adherence to regulatory standards. Our approach is built on trust, accountability, and long-term wealth creation rather than short-term transactions.",
  },
  {
    id: "02",
    img: "/images/core-values/2.avif",
    title: "Research-Driven Excellence",
    text: "We combine data-backed insights, disciplined risk assessment, and market expertise to deliver actionable investment solutions. Our commitment to continuous research helps clients navigate volatility and make informed financial decisions across market cycles.",
  },
  {
    id: "03",
    img: "/images/core-values/3.avif",
    title: (
      <>
        Technology with <br /> Human Insight
      </>
    ),
    text: "We integrate advanced trading platforms and digital processes with personalized relationship management. By blending innovation with expert guidance, we aim to deliver seamless execution, superior client experience, and adaptive solutions in a dynamic market environment.",
  },
];

const WhyUs = () => {
  useEffect(() => {
    if (window.jQuery) {
      const $ = window.jQuery;
      if ($.fn.tab) {
        $(".tab1").tab();
        $(".tab2").tab({ trigger_event_type: "mouseover" });
      }
    }
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="page-content">
      <SEO
        title="Why Choose Us"
        description="Discover why Gateway Financial is India's most trusted investment advisor with 5 market cycles of experience and 5000+ happy clients."
      />

      <section className="service-banner">
        <img
          src="/images/banners/why-us-banner.avif"
          alt="Why Us Banner"
          loading="eager"
          id="service-desktop-banner"
        />
        <img
          src="/images/banners/why-us-mobile-banner.avif"
          alt="Why Us Mobile Banner"
          loading="eager"
          id="service-mobile-banner"
        />
        <div className="services-banner-content">
          <h1 data-aos="fade-up">
            Why Choose <span>Us</span> ?
          </h1>
          <div className="banner-highlights" data-aos="fade">
            <span>Invest</span>
            <span>Grow</span>
            <span>Secure</span>
          </div>
        </div>
      </section>

      <section id="welcome-section" className="why-us-welcome">
        <div className="container">
          <div className="row justify-content-between align-items-center">
            <div className="col-lg-7">
              <h2 data-aos="fade-up">
                <span style={{ fontWeight: 500 }}>
                  We Believe In Results With
                </span>{" "}
                <b>Smart Consulting</b>.
              </h2>
              <p>
                For us, the bottom line has always been your trust for growth.
                We have always focused on providing the best service through
                passion and innovation. Long-term advantages to our clients and
                partners have been our strengths.
              </p>
              <span className="why-us-key-features" data-aos="fade-up">
                Key Features
              </span>
              <p>
                GFSL has been its ability to offer leading edge advice based on
                incisive ideas that are strongly rooted in high quality research
                on every conceivable aspect of investments
              </p>

              <div className="features-hg" data-aos="fade">
                {featureItems.map((item, index) => (
                  <span key={index}>{item}</span>
                ))}
              </div>
            </div>

            <div className="col-lg-4">
              <img
                src="/images/why-us-2.avif"
                alt="Why Us"
                loading="lazy"
                data-aos="fade"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="mission-vision">
        <div className="container">
          <div className="row justify-content-between">
            <div className="mv-content">
              <div className="mv-box">
                <span data-aos="fade-right">Our Mission</span>
                <p data-aos="fade">
                  To empower every investor with personalized financial guidance
                  and transparent, research-driven wealth solutions that grow
                  their financial confidence and safeguard their future.
                </p>
                <p data-aos="fade">
                  Our mission is anchored in long-term trust, education, and
                  proactive partnership so clients feel confident with every
                  financial decision.
                </p>
              </div>
              <div className="mv-box">
                <span data-aos="fade-right">Our Vision</span>
                <p data-aos="fade">
                  To be recognized as India’s most trusted financial partner —
                  distinguished by ethical advisory, client-first innovation,
                  and lifelong financial empowerment.
                </p>
              </div>
            </div>

            <div className="mv-img">
              <img
                src="/images/mission-vision.png"
                alt="Mission Vision"
                loading="lazy"
                className="img-fluid"
                data-aos="fade-up"
              />
            </div>
          </div>
        </div>
      </section>

      <Advantages />

      <section className="core-values container">
        <h3 className="text-center" data-aos="fade-up">
          Our Core Values
        </h3>

        <div className="core-cards-row">
          {coreValuesData.map((card) => (
            <div className="core-card" key={card.id}>
              <img
                src={card.img}
                alt={`Core Value ${card.id}`}
                loading="lazy"
              />
              <span id="core-sl">{card.id}.</span>
              <span id="core-title">{card.title}</span>
              <p>{card.text}</p>
            </div>
          ))}
        </div>
      </section>

      <section id="app-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 align-self-center">
              <h3 data-aos="fade">Download our Investment Fund App</h3>
              <p>Investing With Gateway Financial Services</p>
              <a href="#download" className="lm-btn">
                download &amp; explore more
              </a>
            </div>
            <div className="col-lg-6">
              <img
                src="images/download.avif"
                className="img-fluid"
                alt="Download App"
              />
            </div>
          </div>
        </div>
      </section>

      <FAQ />
    </div>
  );
};

export default WhyUs;
